var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualityPrints255X177(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "255px",
    height: "177px",
    viewBox: "0 0 255 177",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/qualityprints/255x177") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/qualityprints/255x177",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "printer-2",
    transform: "translate(67, 29)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.609375,49.21875 L10.546875,49.21875 C8.60367187,49.21875 7.03125,47.6463281 7.03125,45.703125 L7.03125,31.640625 C7.03125,25.8248438 11.7623437,21.09375 17.578125,21.09375 L24.609375,21.09375 C26.5525781,21.09375 28.125,22.6661719 28.125,24.609375 L28.125,45.703125 C28.125,47.6463281 26.5525781,49.21875 24.609375,49.21875 Z",
    id: "Path",
    fill: "#303026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.96875,45.703125 C112.96875,47.6463281 111.396328,49.21875 109.453125,49.21875 L95.390625,49.21875 C93.4474219,49.21875 91.875,47.6463281 91.875,45.703125 L84.84375,24.609375 C84.84375,22.6661719 86.4161719,21.09375 88.359375,21.09375 L102.421875,21.09375 C108.237656,21.09375 112.96875,25.8248438 112.96875,31.640625 L112.96875,45.703125 Z",
    id: "Path",
    fill: "#303026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.90625,28.125 L98.90625,45.703125 C98.90625,47.6716406 97.3596094,49.21875 95.390625,49.21875 L24.609375,49.21875 C22.6403906,49.21875 21.09375,47.6716406 21.09375,45.703125 L21.09375,3.515625 C21.09375,1.54664063 22.6403906,0 24.609375,0 L70.78125,0 L77.8125,21.09375 L98.90625,28.125 Z",
    id: "Path",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.390625,49.21875 L60,49.21875 L60,0 L70.78125,0 L77.8125,21.09375 L98.90625,28.125 L98.90625,45.703125 C98.90625,47.6716406 97.3596094,49.21875 95.390625,49.21875 Z",
    id: "Path",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.453125,42.1875 L10.546875,42.1875 C4.71070313,42.1875 0,46.8982031 0,52.734375 L0,95.390625 C0,101.226328 4.71070313,105.9375 10.546875,105.9375 L109.453125,105.9375 C115.289297,105.9375 120,101.226328 120,95.390625 L120,52.734375 C120,46.8982031 115.289297,42.1875 109.453125,42.1875 Z",
    id: "Path",
    fill: "#07A0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.78125,24.609375 C70.78125,26.5778906 72.3278906,28.125 74.296875,28.125 L98.90625,28.125 L70.78125,0 L70.78125,24.609375 Z",
    id: "Path",
    fill: "#F41381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,52.734375 L120,95.390625 C120,101.226328 115.289297,105.9375 109.453125,105.9375 L60,105.9375 L60,42.1875 L109.453125,42.1875 C115.289297,42.1875 120,46.8982031 120,52.734375 Z",
    id: "Path",
    fill: "#067A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.609375,63.28125 L17.578125,63.28125 C15.6349219,63.28125 14.0625,61.7088281 14.0625,59.765625 C14.0625,57.8224219 15.6349219,56.25 17.578125,56.25 L24.609375,56.25 C26.5525781,56.25 28.125,57.8224219 28.125,59.765625 C28.125,61.7088281 26.5525781,63.28125 24.609375,63.28125 Z",
    id: "Path",
    fill: "#F41381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.90625,74.9997656 L98.90625,116.484375 C98.90625,118.452891 97.3596094,120 95.390625,120 L24.609375,120 C22.6403906,120 21.09375,118.452891 21.09375,116.484375 L21.09375,74.9997656 L98.90625,74.9997656 Z",
    id: "Path",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.90625,74.9997656 L98.90625,116.484375 C98.90625,118.452891 97.3596094,120 95.390625,120 L60,120 L60,74.9997656 L98.90625,74.9997656 Z",
    id: "Path",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(35.1562, 84.8438)",
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6875,3.515625 C49.6875,5.48414063 48.1408594,7.03125 46.171875,7.03125 L3.515625,7.03125 C1.54664062,7.03125 0,5.48414063 0,3.515625 C0,1.54664062 1.54664062,0 3.515625,0 L46.171875,0 C48.1408594,0 49.6875,1.54664062 49.6875,3.515625 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6875,17.578125 C49.6875,19.5466406 48.1408594,21.09375 46.171875,21.09375 L3.515625,21.09375 C1.54664062,21.09375 0,19.5466406 0,17.578125 C0,15.6091406 1.54664062,14.0625 3.515625,14.0625 L46.171875,14.0625 C48.1408594,14.0625 49.6875,15.6091406 49.6875,17.578125 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(60, 84.8438)",
    fill: "#8B8892"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.84375,17.578125 C24.84375,19.5466406 23.2971094,21.09375 21.328125,21.09375 L0,21.09375 L0,14.0625 L21.328125,14.0625 C23.2971094,14.0625 24.84375,15.6091406 24.84375,17.578125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.84375,3.515625 C24.84375,5.48414063 23.2971094,7.03125 21.328125,7.03125 L0,7.03125 L0,0 L21.328125,0 C23.2971094,0 24.84375,1.54664062 24.84375,3.515625 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.9375,74.296875 C105.9375,76.2653906 104.390859,77.8125 102.421875,77.8125 L17.578125,77.8125 C15.6091406,77.8125 14.0625,76.2653906 14.0625,74.296875 C14.0625,72.3278906 15.6091406,70.78125 17.578125,70.78125 L102.421875,70.78125 C104.390859,70.78125 105.9375,72.3278906 105.9375,74.296875 Z",
    id: "Path",
    fill: "#303026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9375,74.296875 C105.9375,76.2653906 104.390859,77.8125 102.421875,77.8125 L60,77.8125 L60,70.78125 L102.421875,70.78125 C104.390859,70.78125 105.9375,72.3278906 105.9375,74.296875 Z",
    id: "Path",
    fill: "#303026"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityPrints255X177);
export default __webpack_public_path__ + "static/media/quality-prints_255x177.084f66bb373925989676649b73f01ce7.svg";
export { ForwardRef as ReactComponent };